module.exports = __webpack_public_path__ + "img/61.e0849e92.png";